import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {BranchModel} from "../../models/branch.model";

export class branchesDisplayListCtrl implements IController {
  ids: string[];
  noBranches?: boolean;
  excludeIds: string[];
  isRow: any;
  rowLimit: any;
  onChange: Function;
  onChangeNoBranches: Function;

  private displayItems: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private branchesRequests, private $log) {
  }

  $onInit() {
    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }

    if (changes.excludeIds) {
      this.excludeKeys = {};
      this.excludeIds?.forEach(id => {
        this.excludeKeys[id] = true;
      })
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.branchesRequests.getBranchesByIds(ids)
        .then((branches: BranchModel[]) => {
          const displayItems = [];
          _.forEach(branches, (b: BranchModel) => {
            displayItems.push({id: b.id, value: b.name})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.branches')
  .component('branchesDisplayList', {
    bindings: {
      ids: '<',
      noBranches: '<?',
      excludeIds: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&',
      onChangeNoBranches: '&'
    },
    template: require('./branches-display-list.html').default,
    controller: branchesDisplayListCtrl
  });
